<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="chap1">Edward Whittemore’s Sinai Tapestry</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 8-chap1.vue?2ef21340